import { websiteProductionHost } from "scripts/application/setting";

export function StaticMap(props: {
  latitude: number;
  longitude: number;
  zoom?: number;
  width?: number;
  height?: number;
}) {
  const { latitude, longitude, zoom = 12, width = 230, height = 180 } = props;

  return (
    <img
      className="staticmap-img"
      src={`${websiteProductionHost}/api/staticmap?sensor=false&zoom=${zoom}&center=${latitude},${longitude}&markers=icon:https://www.har.com/img/icons/pin_general.png%7C${latitude},${longitude}&client=gme-houstonrealtorsinformation&token=aisearch&size=${width}x${height}`}
      alt="Static map"
      style={{ width: `${width}px`, height: `${height}px` }}
    />
  );
}
